module.exports = "../images/perch@2x.jpg?v=1d4d3d7";